import React, { Fragment, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./AppLayout";
import appRoutes from "./appRoutes";
import authRoutes from "./authRoutes";
import PrivateLayout from "./PrivateLayout";
import logo from "../assets/logo/logo.svg";
import Login from "../auth/login/Login";
import { useSelector } from "react-redux";

const mergedRoutes = [...authRoutes, ...appRoutes];

const MergeLayoutRoute = (props) => {
  const { children, route } = props;

  const AppLayoutWrapper = route.meta.appLayout ? AppLayout : Fragment;
  const PrivateRouteWrapper = route.meta.privateRoute
    ? PrivateLayout
    : Fragment;

  if (route.meta.privateRoute) {
    return <AppLayoutWrapper>{children}</AppLayoutWrapper>;
  } else {
    return <PrivateRouteWrapper>{children}</PrivateRouteWrapper>;
  }
};

const Router = () => {
  const loginStatus = useSelector((state) => {
    return state.user.loginStatus;
  });

  return (
    <BrowserRouter>
      {!loginStatus ? (
        <Routes>
          <Route path="*" element={<Login />} />
        </Routes>
      ) : (
        <Routes>
          {mergedRoutes.map((route) => {
            return (
              <Route
                key={route.id}
                path={route.path}
                exact={route.exact}
                element={
                  <Suspense
                    fallback={
                      <div className="flex w-full h-[100vh] items-center justify-center">
                        <img src={logo} alt="Logo" className="w-[150px]" />
                      </div>
                    }
                  >
                    <MergeLayoutRoute route={route}>
                      <route.component />
                    </MergeLayoutRoute>
                  </Suspense>
                }
              />
            );
          })}
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default Router;
